var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.5,
    width: 62,
    height: 62,
    rx: 31,
    fill: "#00ABAB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.5,
    width: 62,
    height: 62,
    rx: 31,
    stroke: "#B3F8EB",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3335 30.4974C22.3335 29.1019 22.8963 28.2466 24.0609 27.5985L28.855 24.9305C31.3671 23.5325 32.6232 22.8335 34.0002 22.8335C35.3772 22.8335 36.6332 23.5325 39.1453 24.9305L43.9394 27.5985C45.104 28.2466 45.6668 29.1019 45.6668 30.4974C45.6668 30.8758 45.6668 31.065 45.6255 31.2206C45.4084 32.0378 44.6678 32.1668 43.9527 32.1668H24.0477C23.3325 32.1668 22.5919 32.0378 22.3748 31.2206C22.3335 31.065 22.3335 30.8758 22.3335 30.4974Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9954 28.6665H34.0059",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.667 32.167V42.0837M29.3337 32.167V42.0837",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.667 32.1665V42.0832M43.3337 32.1665V42.0832",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1668 42.0835H25.8335C23.9005 42.0835 22.3335 43.6505 22.3335 45.5835C22.3335 45.9057 22.5947 46.1668 22.9168 46.1668H45.0835C45.4057 46.1668 45.6668 45.9057 45.6668 45.5835C45.6668 43.6505 44.0998 42.0835 42.1668 42.0835Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBank);
export default __webpack_public_path__ + "static/media/empty-bank.8202e659408a13c9eafd0a69e460ab75.svg";
export { ForwardRef as ReactComponent };